function copenhagenParts(timestamp) {
  const parts = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Europe/Copenhagen', year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23',
  }).formatToParts(new Date(timestamp));
  return Object.fromEntries(parts.filter(p => p.type !== 'literal').map(p => [p.type, Number(p.value)]));
}

function parseCopenhagenDeadline(date, time) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(date || '') || !/^\d{2}:\d{2}$/.test(time || '')) return null;
  const [year, month, day] = date.split('-').map(Number);
  const [hour, minute] = time.split(':').map(Number);
  const target = Date.UTC(year, month - 1, day, hour, minute);
  if (month < 1 || month > 12 || day < 1 || day > 31 || hour > 23 || minute > 59) return null;
  let guess = target;
  for (let i = 0; i < 3; i++) {
    const p = copenhagenParts(guess);
    const represented = Date.UTC(p.year, p.month - 1, p.day, p.hour, p.minute, p.second);
    guess += target - represented;
  }
  const p = copenhagenParts(guess);
  // Reject invalid dates and the nonexistent spring clock-change hour.
  return p.year === year && p.month === month && p.day === day && p.hour === hour && p.minute === minute ? guess : null;
}

function countdownParts(deadline, now) {
  const seconds = Math.max(0, Math.floor((deadline - now) / 1000));
  return { days: Math.floor(seconds / 86400), hours: Math.floor(seconds % 86400 / 3600),
    minutes: Math.floor(seconds % 3600 / 60), seconds: seconds % 60 };
}

class DBKClearanceCountdown extends HTMLElement {
  connectedCallback() {
    this.deadline = parseCopenhagenDeadline(this.dataset.date, this.dataset.time);
    if (this.deadline === null) {
      this.hidden = this.dataset.preview !== 'true';
      if (!this.hidden) {
        this.querySelector('[data-countdown-heading]').textContent = 'Slutdato for lagerudsalget';
        this.querySelector('[data-countdown-preview-note]').hidden = false;
      }
      return;
    }
    this.tick();
    this.timer = setInterval(() => this.tick(), 1000);
  }
  disconnectedCallback() { clearInterval(this.timer); }
  tick() {
    this.hidden = Date.now() >= this.deadline;
    if (this.hidden) { clearInterval(this.timer); return; }
    const parts = countdownParts(this.deadline, Date.now());
    for (const [unit, value] of Object.entries(parts)) {
      this.querySelector(`[data-countdown-${unit}]`).textContent = String(value).padStart(2, '0');
    }
  }
}
if (!customElements.get('dbk-clearance-countdown')) customElements.define('dbk-clearance-countdown', DBKClearanceCountdown);
